const visileColumns = [
  {
    title: "Employee ID",
    field: "EmployeeId",
    locked: false,
    filter: "numeric",
    customFilterType: "CustomNumericText",
    minWidth: 250,
    show: true,
  },
  {
    title: "Control No",
    field: "HrControl",
    locked: false,
    filter: "text",
    minWidth: 200,
    show: true,
  },
  {
    title: "Action No",
    field: "ActnNo",
    locked: false,
    filter: "text",
    minWidth: 200,
    show: true,
  },
  {
    title: "Request ID",
    field: "RequestId",
    locked: false,
    filter: "text",
    minWidth: 190,
    show: true,
  },
  {
    title: "Nature Of Action",
    field: "NatureTitle",
    locked: false,
    filter: "text",
    minWidth: 250,
    Width: "auto",
    show: true,
  },
  {
    title: "Employee Name",
    field: "ToFullName",
    locked: false,
    filter: "text",
    minWidth: 250,
    show: true,
  },
  {
    title: "Department",
    field: "FromDepartment",
    locked: false,
    filter: "text",
    minWidth: 250,
    show: true,
  },
  {
    title: "Status",
    field: "CurrentProcessStatus",
    locked: false,
    filter: "text",
    minWidth: 180,
    show: true,
  },
  {
    title: "Legal Authority",
    field: "LegalAuthority",
    locked: false,
    filter: "text",
    minWidth: 180,
    width: "auto",
    show: true,
  },
  {
    title: "Job Order NO",
    field: "JobOrderNumber",
    locked: false,
    filter: "text",
    minWidth: 190,
    show: true,
  },
  {
    title: "Effective Date",
    field: "ActionEffectiveDate",
    locked: false,
    filter: "date",
    minWidth: 200,
    show: true,
    format: "MM/DD/yyyy",
    editor: "date",
  },
  {
    title: "Action Date",
    field: "ActionDate",
    locked: false,
    filter: "date",
    minWidth: 200,
    show: true,
    format: "MM/DD/yyyy",
    editor: "date",
  },
];

export default visileColumns;
